import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { getAccess } from './lib/api'
import Login from './pages/Login'
import Dashboard from './pages/Dashboard'
import Tenants from './pages/Tenants'
import TenantDetail from './pages/TenantDetail'
import Tickets from './pages/Tickets'
import AICopilot from './pages/AICopilot'
import Analytics from './pages/Analytics'
import Billing from './pages/Billing'
import Growth from './pages/Growth'
import Ops from './pages/Ops'
import Audit from './pages/Audit'
import Operators from './pages/Operators'
import Sessions from './pages/Sessions'
import Impersonations from './pages/Impersonations'
import PlatformIntegrations from './pages/PlatformIntegrations'
import Layout from './components/Layout'
import './styles.css'

function Protected({ children }: { children: JSX.Element }) {
  return getAccess() ? children : <Navigate to="/login" replace />
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Protected><Layout /></Protected>}>
          <Route index element={<Dashboard />} />
          <Route path="tenants" element={<Tenants />} />
          <Route path="tenants/:id" element={<TenantDetail />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="billing" element={<Billing />} />
          <Route path="growth" element={<Growth />} />
          <Route path="ops" element={<Ops />} />
          <Route path="audit" element={<Audit />} />
          <Route path="platform" element={<PlatformIntegrations />} />
          <Route path="operators" element={<Operators />} />
          <Route path="sessions" element={<Sessions />} />
          <Route path="impersonations" element={<Impersonations />} />
          <Route path="ai" element={<AICopilot />} />
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
